/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SiteContextModel } from '../models/site-context-model';
import { SiteContentSource } from '../models/site-content-source';

/**
 * Site Rest Controller
 */
@Injectable({
  providedIn: 'root',
})
class SiteRestControllerService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  getCurrentSiteUsingGETResponse(): __Observable<__StrictHttpResponse<SiteContextModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteContextModel>;
      })
    );
  }
  /**
   * @return OK
   */
  getCurrentSiteUsingGET(): __Observable<SiteContextModel> {
    return this.getCurrentSiteUsingGETResponse().pipe(
      __map(_r => _r.body as SiteContextModel)
    );
  }

  /**
   * @return OK
   */
  listContentSourceUsingGETResponse(): __Observable<__StrictHttpResponse<Array<SiteContentSource>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/site/contentsources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteContentSource>>;
      })
    );
  }
  /**
   * @return OK
   */
  listContentSourceUsingGET(): __Observable<Array<SiteContentSource>> {
    return this.listContentSourceUsingGETResponse().pipe(
      __map(_r => _r.body as Array<SiteContentSource>)
    );
  }

  /**
   * @param siteContentSource siteContentSource
   * @return OK
   */
  updateContentSourceUsingPOSTResponse(siteContentSource: SiteContentSource): __Observable<__StrictHttpResponse<SiteContentSource>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = siteContentSource;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/site/contentsources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteContentSource>;
      })
    );
  }
  /**
   * @param siteContentSource siteContentSource
   * @return OK
   */
  updateContentSourceUsingPOST(siteContentSource: SiteContentSource): __Observable<SiteContentSource> {
    return this.updateContentSourceUsingPOSTResponse(siteContentSource).pipe(
      __map(_r => _r.body as SiteContentSource)
    );
  }
}

module SiteRestControllerService {
}

export { SiteRestControllerService }
